import React from "react";

import email_options from "./email_options.png";
import welcome_email_preview from "./welcome_email_preview.png";
import edit_welcome_email from "./edit_welcome_email.png";
import { Link } from "react-router-dom";

const EmailingUserCredentials = () => (
  <div id="admin_email_user" className="section">
    <h2>3.1.1 Email User Credentials and Portal Details</h2>
    <p>
      When adding a new user to the portal you may choose whether or not they are emailed with their{" "}
      <strong>logon credentials</strong> and <strong>portal details</strong>. The portal admin
      system is set to <strong>Email access details to user</strong> by default however this may be
      changed, options include:
    </p>
    <img src={email_options} alt="Create user email options" className="center" />
    <h3>Email access details to user</h3>
    <p>
      Upon addition of a new user, logon credentials and portal details are automatically emailed
      using the email address that was supplied. You will be notified as to whether or not the email
      was sent successfully, please ensure that a valid email address is supplied.
    </p>
    <p>
      If you are sure that you have entered a correct email address but an error is shown, be sure
      to check that other details on the email template are correct. Such as <strong>cc</strong>,{" "}
      &nbsp;
      <strong>bcc</strong>, incorrect entries here will prevent the email from being sent.
    </p>
    <h3>Email access details to user [Preview First].</h3>
    <p>
      Emails can be customised prior to sending, if you choose the <strong>Preview First</strong>{" "}
      option and then click <strong>Create User</strong>, a popup box with the standard{" "}
      <strong>welcome email</strong> template will appear. Edit the <strong>email subject</strong>{" "}
      and <strong>email body</strong> to suit your needs, any changes here will <u>not</u> be saved
      as a customised item but sent as an email.
    </p>
    <p>
      You may wish to include additional information that will only be applicable to a single user.
      Click <strong>Send</strong> and the email will be sent, you will be notified of its success or
      failure. If successful, click <strong>close</strong> and the preview popup will disappear.
    </p>
    <br />
    <img src={welcome_email_preview} alt="Preview Email" className="center" />
    <h3>
      <u>Don't</u> email access details to user
    </h3>
    <p>
      Choosing this will mean that no email will get sent on user creation, however if you later
      wish to send the user an email you may do so from the created user page by clicking
      <strong>preview/send email</strong> button.
    </p>
    <h2>Edit Template</h2>
    <p>
      If you wish to alter the <strong>welcome email</strong> for a number of users, it would be
      best to{" "}
      <Link to={"/help/customisation/customise_editable_actions/editing_email_templates"}>
        {" "}
        edit the <strong>welcome email</strong> template{" "}
      </Link>{" "}
      first. Editing an email template will allow you to specify specific <strong>CC, BCC</strong>{" "}
      fields. By default, these are set to be the portal administrators contact details.
    </p>
    <br />
    <img src={edit_welcome_email} alt="Edit Template" className="center" />
  </div>
);

export default EmailingUserCredentials;
